import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { UntypedFormControl } from '@angular/forms';
import { KieneSession } from '../../../projects/kiene-core/src/lib/services/local-storage/kiene-session';
import { HttpParams } from '@angular/common/http';
import { API_BASE_URL_SERVICE } from '../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { Mandant } from '../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { MessageService } from '../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { UserCredentials } from '../../../projects/kiene-core/src/lib/components/client/classes/user';
import { LoginService } from '../../../projects/kiene-core/src/lib/services/user/login.service';
import { ChangeCurrentClientService } from '../administration/client/change-current-client/change-current-client.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    host: { '(window:keydown)': 'checkForF8($event)' },
})
export class LoginComponent implements OnInit {
    hidePassword = true;
    isLoading = false;

    emailCtrl = new UntypedFormControl();
    passwordCtrl = new UntypedFormControl();

    @ViewChild('emailInput') emailInputRef!: ElementRef<HTMLInputElement>;
    @ViewChild('passwordInput') passwordInputRef!: ElementRef<HTMLInputElement>;

    constructor(
        private loginService: LoginService,
        private router: Router,
        private localStorageService: LocalStorageService,
        private messageService: MessageService,
        private route: ActivatedRoute,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private changeCurrentClientService: ChangeCurrentClientService,
    ) {}

    ngOnInit() {
        if (this.localStorageService.isLoggedIn()) {
            this.logout('LoginComponent init');
        }

        const email = this.route.snapshot.queryParamMap.get('email');
        if (email) {
            this.emailCtrl.setValue(email);
        }
    }

    checkForF8(event: any) {
        if (event.code === 'F8') {
            this.hidePassword = !this.hidePassword;
        }
    }

    private mandantAuswaehlen(session: KieneSession): void {
        if (session?.mandanten?.length === 1) {
            this.setSessionAndMandant(session, session.mandanten[0]);
        } else {
            this.changeCurrentClientService.openChangeMandantDialog(true, session);
        }
    }

    login() {
        this.isLoading = true;
        this.localStorageService.deleteBrowserSession('login');
        const userCredentials: UserCredentials = new UserCredentials();

        userCredentials.email = this.emailCtrl.value;
        userCredentials.passwort = this.passwordCtrl.value;

        const emailEmpty = !userCredentials.email || userCredentials.email.trim() === '';
        const passwordEmpty = !userCredentials.passwort || userCredentials.passwort.trim() === '';

        if (emailEmpty && passwordEmpty) {
            this.emailCtrl.markAsTouched();
            this.passwordCtrl.markAsTouched();
            this.emailCtrl.setErrors({ required: true });
            this.passwordCtrl.setErrors({ required: true });
            // Fokus auf E-Mail-Feld
            setTimeout(() => {
                if (this.emailInputRef) {
                    this.emailInputRef.nativeElement.focus();
                }
            });
            this.isLoading = false;
            return;
        } else if (emailEmpty) {
            this.emailCtrl.markAsTouched();
            this.emailCtrl.setErrors({ required: true });
            // Fokus auf E-Mail-Feld
            setTimeout(() => {
                if (this.emailInputRef) {
                    this.emailInputRef.nativeElement.focus();
                }
            });
            this.isLoading = false;
            return;
        } else if (passwordEmpty) {
            this.passwordCtrl.markAsTouched();
            this.passwordCtrl.setErrors({ required: true });
            // Fokus auf Passwort-Feld
            setTimeout(() => {
                if (this.passwordInputRef) {
                    this.passwordInputRef.nativeElement.focus();
                }
            });
            this.isLoading = false;
            return;
        }

        this.loginService.login(userCredentials).subscribe({
            next: (response: KieneSession) => {
                this.isLoading = false;
                this.mandantAuswaehlen(response);
            },
            error: err => {
                this.messageService.errorMessage('Login fehlgeschlagen!', err);
                this.isLoading = false;
            },
        });
    }

    private setSessionAndMandant(session: KieneSession, mandant: Mandant): void {
        this.localStorageService.setCurrentClient(null, 'LoginComponent');
        this.localStorageService.setCurrentUser(session);
        this.localStorageService.setCurrentMandant(mandant);

        this.loadClientsAndSelect();

        const startseite = this.localStorageService.getStartseite();
        this.router.navigate([startseite]).then();
    }

    loadClientsAndSelect() {
        if (this.localStorageService.isCurrentUserKunde() || this.localStorageService.isCurrentUserViehhaendler()) {
            this.api.getAll(this.apiBaseUrl + 'kunde/search.php', new HttpParams().set('limit', '2')).subscribe({
                next: response => {
                    if (response.count === 1) {
                        this.localStorageService.setCurrentClient(response.records[0], 'LoginComponent');
                    }
                },
                error: () => {
                    // messageservice zirkulär fehler
                },
            });
        }
    }

    logout(sender: string) {
        this.localStorageService.deleteBrowserSession(sender);
    }

    register() {
        this.logout('register');
        this.router.navigate(['/register']).then();
    }

    resetPassword() {
        this.logout('resetPassword');
        this.router.navigate(['/password/reset']).then();
    }
}
